import {
  ReportSummarySchema,
  SalesReportSchema,
  StaffReportSchema,
} from '@contracts/schemas/reports.schema';
import type {
  ReportRange,
  ReportRepository,
  ReportSummary,
  SalesFilter,
  SalesReport,
  StaffPeriod,
  StaffReport,
} from '@/application/ports/ReportRepository';
import { request } from '../client';

export class HttpReportRepository implements ReportRepository {
  async summary(range: ReportRange): Promise<ReportSummary> {
    return request(`/reports/summary?range=${range}`, { schema: ReportSummarySchema });
  }

  async sales(filter: SalesFilter): Promise<SalesReport> {
    const params = new URLSearchParams({ range: filter.range });
    if (filter.dentist !== undefined && filter.dentist !== 'all') {
      params.set('dentist', filter.dentist);
    }
    if (filter.origin !== undefined && filter.origin !== 'all') {
      params.set('origin', filter.origin);
    }

    return request(`/reports/sales?${params.toString()}`, { schema: SalesReportSchema });
  }

  async staff(period: StaffPeriod, mine = false): Promise<StaffReport> {
    const range =
      typeof period === 'string' ? period : `custom&from=${period.from}&to=${period.to}`;
    const own = mine ? '&me=true' : '';
    return request(`/reports/staff?range=${range}${own}`, { schema: StaffReportSchema });
  }
}
